/* src/app/views/area-publica/home-page/home-page-area-publica/home-page-area-publica.component.scss */
.background-logo {
  background-image: url(/assets/homePage/homePageimg.png);
  height: calc(100vh - 181px);
  background-size: 100% 100%;
  padding-left: 10%;
  padding-right: 10%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  position: relative;
}
.titulo-logo {
  text-align: left;
  font: normal normal 800 80px/80px "Alegreya Sans ExtraBold", sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  margin: 0;
}
.subtitulo-logo {
  font: normal normal normal 42px/58px "Alegreya Sans Regular", sans-serif;
  letter-spacing: 0px;
  margin: 0;
  color: #FFFFFF;
}
#container-btn-saiba-mais-logo {
  width: 64px;
  height: 64px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.1607843137);
  display: flex;
  border-radius: 100%;
  margin-bottom: 20px;
}
#container-btn-saiba-mais-logo img {
  margin: auto;
  display: block;
}
#container-saiba-mais {
  position: absolute;
  bottom: -76px;
  left: 0;
  right: 0;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}
#container-saiba-mais span {
  font-family: "Alegreya Sans Regular", sans-serif;
  font-size: 20px;
  color: #284395;
}
#container-descricao-ecossistema {
  background-color: white;
  min-height: 230px;
  display: block;
  align-items: center;
  padding-left: 291px;
  padding-right: 291px;
  padding-top: 193px;
}
#texto-descricao-ecossistema-conteudo {
  padding-bottom: 115px;
}
#vertentes-container {
  background-color: white;
  padding: 120px 2% 120px 2%;
  scroll-margin: -100px;
}
#container-texto-vertentes {
  padding-left: 10%;
  padding-right: 10%;
}
#titulo-vertentes {
  text-align: center;
  font: normal normal bold 50px/52px "Alegreya Sans Bold", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin-top: 0;
}
#subtitulo-vertentes {
  text-align: center;
  font: normal normal normal 34px/34px "Alegreya Sans Regular", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin-top: 25px;
  padding-bottom: 76px;
}
#containter-timings {
  background: #FBFBFB 0% 0% no-repeat padding-box;
  scroll-margin: -100px;
}
#containter-timings #content-timings {
  padding: 120px 32% 160px 32%;
  text-align: center;
}
#containter-timings #content-timings #titulo-timings,
#containter-timings #content-timings #titulo-timings span {
  font: normal normal bold 50px/52px "Alegreya Sans Bold", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin: 0;
  padding-bottom: 60px;
}
#containter-timings #content-timings #titulo-timings span,
#containter-timings #content-timings #titulo-timings span span {
  font-style: italic;
}
#texto-ciclo-recompensa {
  font: normal normal normal 24px/36px "Alegreya Sans Regular", sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  max-width: 80%;
}
.destaque-texto-ciclo-recompensa {
  font: normal normal bold 24px/36px "Alegreya Sans Bold", sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
}
#ciclo-folder-container {
  background: url("./media/ciclo_recompensa_mutuo.jpg");
  background-size: cover;
  padding: 0 6.25% 0 6.25%;
  text-align: right;
  display: flex;
  align-items: center;
}
#ciclo-descricao {
  background-color: #284395;
  padding: 0 4.89% 0 4.89%;
  text-align: left;
  display: flex;
  align-items: center;
}
#container-ciclo-recompensa {
  display: flex;
  min-height: 660px;
}
#label-folder-ciclo-recompensa {
  font: normal normal bold 80px/82px "Alegreya Sans Bold", sans-serif;
  letter-spacing: 0px;
  color: #FBFBFB;
}
#container-ciclo {
  padding: 12.1% 233px 12.1% 233px;
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  scroll-margin: -200px;
}
#titulo-ciclo {
  text-align: left;
  font: normal normal bold 50px/52px "Alegreya Sans Bold", sans-serif;
  letter-spacing: 0px;
  color: #757575;
}
#texto-ciclo {
  text-align: left;
  font: normal normal normal 24px/34px "Alegreya Sans Regular", sans-serif;
  letter-spacing: 0px;
  color: #757575;
}
#grafico-ciclo {
  max-width: 790px;
}
#container-texto-ciclo {
  padding-right: 75px;
}
.ciclo-flex-item {
  flex: 1;
}
#container-mapa {
  background-color: #FBFBFB;
  padding-left: 10%;
  padding-right: 10%;
  text-align: center;
  padding-top: 120px;
  padding-bottom: 120px;
  scroll-margin: -100px;
}
#titulo-mapa {
  text-align: center;
  padding-left: 10%;
  padding-right: 10%;
  font: normal normal 800 50px/52px "Alegreya Sans Bold", sans-serif;
  letter-spacing: 0px;
  color: #757575;
  margin: 0;
}
#subtitulo-mapa {
  text-align: center;
  font: normal normal normal 24px/34px "Alegreya Sans Regular", sans-serif;
  letter-spacing: 0px;
  color: #757575;
}
#container-mapa-qtd-projs {
  display: flex;
  flex-wrap: wrap;
}
#mapa-brasil-component {
  flex: 1;
}
:host ::ng-deep #mapa-brasil-component svg {
  width: 100% !important;
}
.btn-voltar-mapa {
  text-align: center;
  font: normal normal normal 16px/30px "Alegreya Sans Medium", sans-serif;
  letter-spacing: 0px;
  color: #007AC2;
  padding-bottom: 15px;
}
#qtd-projs-container {
  width: 500px;
}
@media screen and (max-width: 1770px) {
  #container-mapa,
  .background-logo {
    padding-left: 3%;
    padding-right: 3%;
  }
  #container-ciclo {
    padding-left: 8%;
    padding-right: 8%;
  }
}
@media screen and (max-width: 1614px) {
  .subtitulo-logo {
    max-width: 427px;
  }
}
@media screen and (max-width: 1400px) {
  #qtd-projs-container {
    width: 370px;
  }
}
@media screen and (max-width: 1300px) {
  #container-ciclo {
    flex-direction: column;
    align-items: center;
    align-content: center;
  }
  #container-mapa-qtd-projs {
    flex-direction: column;
    align-items: center;
  }
  :host ::ng-deep #mapa-brasil-component svg {
    width: 750px !important;
  }
}
@media screen and (min-width: 1300px) {
  #grafico-ciclo {
    width: 100%;
  }
  #container-grafico-ciclo {
    width: 50%;
  }
}
@media screen and (max-width: 1312px) {
  app-button a {
    padding: 0;
  }
}
:host ::ng-deep .ql-align-right {
  text-align: right;
}
:host ::ng-deep .ql-align-center {
  text-align: center;
}
:host ::ng-deep .ql-align-left {
  text-align: left;
}
:host ::ng-deep :host ::ng-deep .ql-align-justify {
  text-align: justify;
}
:host ::ng-deep .ql-size-small {
  font-size: 0.75em;
}
:host ::ng-deep .ql-size-large {
  font-size: 1.5em;
}
:host ::ng-deep .ql-size-huge {
  font-size: 2.5em;
}
:host ::ng-deep .ql-bg-black {
  background-color: #000;
}
:host ::ng-deep .ql-bg-red {
  background-color: #e60000;
}
:host ::ng-deep .ql-bg-orange {
  background-color: #f90;
}
:host ::ng-deep .ql-bg-yellow {
  background-color: #ff0;
}
:host ::ng-deep .ql-bg-green {
  background-color: #008a00;
}
:host ::ng-deep .ql-bg-blue {
  background-color: #06c;
}
:host ::ng-deep .ql-bg-purple {
  background-color: #93f;
}
:host ::ng-deep .ql-color-white {
  color: #fff;
}
:host ::ng-deep .ql-color-red {
  color: #e60000;
}
:host ::ng-deep .ql-color-orange {
  color: #f90;
}
:host ::ng-deep .ql-color-yellow {
  color: #ff0;
}
:host ::ng-deep .ql-color-green {
  color: #008a00;
}
:host ::ng-deep .ql-color-blue {
  color: #06c;
}
:host ::ng-deep .ql-color-purple {
  color: #93f;
}
/*# sourceMappingURL=home-page-area-publica.component.css.map */
